import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class CancelPurchaseOrderServiceArgs extends ActionArgs {
  @Field(() => String)
  purchaseOrderId: string
}
